import { render, staticRenderFns } from "./registro_proveedor_exito.vue?vue&type=template&id=f5bc696a&scoped=true&"
import script from "./registro_proveedor_exito.vue?vue&type=script&lang=js&"
export * from "./registro_proveedor_exito.vue?vue&type=script&lang=js&"
import style0 from "./registro_proveedor_exito.vue?vue&type=style&index=0&id=f5bc696a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bc696a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VFlex,VImg})
